import { render, staticRenderFns } from "./input-padding.vue?vue&type=template&id=751dd03f&scoped=true"
import script from "./input-padding.vue?vue&type=script&lang=js"
export * from "./input-padding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751dd03f",
  null
  
)

export default component.exports